// removed by extract-text-webpack-plugin
module.exports = {"languageSwitch":"_3P1cTBlL7LTmTuLbDJKsgG","largeIcons":"_2fm_Jcch-J5CZ8LDamrSLt","right":"ituqSY2w-FDsnIhHUMRgl","left":"BZwLHLlCiIAxlWzt5AAlw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageSwitch/LanguageSwitch.scss
// module id = 1613
// module chunks = 0